module.exports = __webpack_public_path__ + "Roboto-Bold.ab96cca26751239828b8.woff2";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-Bold.woff2
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Bold.woff2
// module chunks = 5